import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import CustomButton from "../../../Components/Atoms/CustomButton";
import CustomInput from "../../../Components/Atoms/CustomInput";
import Close from "@mui/icons-material/Close";
import { getEmployeeListRequest } from "../../../Redux/Employees/EmployeesActions";
import { getMasterListRequest } from "../../../Redux/Master/MasterActions";
import { MASTER_SETTINGS } from "../../../Constant";

const VisitorLogsdFilter = (props) => {
  const dispatch = useDispatch();

  const { searchFormik, handleFilterClose, handleFilter } = props;

  const { EmployeeListPageResponse } = useSelector((state) => state.employee);
  const { getMasterListResponse } = useSelector((state) => state.masterReducer);

  useEffect(() => {
    dispatch(
      getEmployeeListRequest({
        filters: {
          search: {
            value: "",
          },
        },
        limit: "",
        page: "",
        sort: "first_name:asc",
      })
    );
    dispatch(
      getMasterListRequest({
        filters: {
          search: {
            value: "",
          },
          type: {
            value: [MASTER_SETTINGS.TYPE, MASTER_SETTINGS.PURPOSE_OF_VISIT],
            type: "array",
          },
        },
        limit: "",
        page: "",
        sort: "name:asc",
      })
    );
  }, []);
  return (
    <div className="MainFilter">
      <div className="d-flex justify-content-between align-items-center">
        <p className="title">FILTER VISITOR LOGS</p>
        <Close style={{ cursor: "pointer" }} onClick={handleFilterClose} />
      </div>
      <form onSubmit={searchFormik.handleSubmit} className="filterTable">
        <div className="w-100">
          <div className="customInputWrpr mt-3 row">
            <p className="mb-1">Check-in Date</p>
            <div className="col-md-6">
              <CustomInput
                remove_class={true}
                type="date"
                name={`filters["basic_details.check_in"].value[0]`}
                value={
                  searchFormik.values.filters["basic_details.check_in"]
                    .value[0] || ""
                }
                onChange={searchFormik.handleChange}
                onBlur={searchFormik.handleBlur}
                formik={searchFormik}
                errorMsgCls={"ml-15"}
                errorMsg={
                  searchFormik.errors?.filters?.["basic_details.check_in"]
                    ?.value?.[0]
                }
              />
            </div>
            <div className="col-md-6">
              <CustomInput
                type="date"
                remove_class={true}
                name={`filters["basic_details.check_in"].value[1]`}
                value={
                  searchFormik.values.filters["basic_details.check_in"]
                    .value[1] || ""
                }
                onChange={searchFormik.handleChange}
                onBlur={searchFormik.handleBlur}
                formik={searchFormik}
                errorMsgCls={"ml-15"}
                errorMsg={
                  searchFormik.errors?.filters?.["basic_details.check_in"]
                    ?.value?.[1]
                }
              />
            </div>
          </div>

          <div className="customInputWrpr mt-3">
            <p className="mb-1">Status</p>
            <Autocomplete
              name="filters.status.value"
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              multiple
              id="filters.status.value"
              options={[
                { name: "CHECKIN", value: "CHECKIN" },
                { name: "CHECKOUT", value: "CHECKOUT" },
                // { name: "CANCELLED", value: "CANCELLED" },
              ]}
              className="w-100"
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?.value} //
              defaultValue={[]}
              filterSelectedOptions
              size="small"
              limitTags={2}
              onChange={(event, newValue) => {
                searchFormik.setFieldValue("filters.status.value", newValue);
              }}
              onBlur={searchFormik.handleBlur}
              value={searchFormik.values?.filters?.status?.value || []}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>

          <div className="customInputWrpr mt-3">
            <p className="mb-1">Type</p>
            <Autocomplete
              name="filters.[`other_details.type`].value"
              multiple
              id="filters.[`other_details.type`].value"
              options={
                getMasterListResponse?.data?.filter(
                  (e) => e.type === MASTER_SETTINGS.TYPE
                ) || []
              }
              className="w-100"
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?._id} //
              defaultValue={[]}
              filterSelectedOptions
              size="small"
              limitTags={2}
              onChange={(event, newValue) => {
                searchFormik.setFieldValue(
                  `filters.["other_details.type"].value`,
                  newValue
                );
              }}
              onBlur={searchFormik.handleBlur}
              value={
                searchFormik.values?.filters?.["other_details.type"]?.value ||
                []
              }
              renderInput={(params) => <TextField {...params} />}
            />
          </div>

          <div className="customInputWrpr mt-3">
            <p className="mb-1">Purpose Of Visit</p>
            <Autocomplete
              name="filters.[`other_details.purpose_of_visit`].value"
              multiple
              id="filters.[`other_details.purpose_of_visit`].value"
              options={
                getMasterListResponse?.data?.filter(
                  (e) => e.type === MASTER_SETTINGS.PURPOSE_OF_VISIT
                ) || []
              }
              className="w-100"
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?._id} //
              defaultValue={[]}
              filterSelectedOptions
              size="small"
              limitTags={2}
              onChange={(event, newValue) => {
                searchFormik.setFieldValue(
                  `filters.["other_details.purpose_of_visit"].value`,
                  newValue
                );
              }}
              onBlur={searchFormik.handleBlur}
              value={
                searchFormik.values?.filters?.["other_details.purpose_of_visit"]
                  ?.value || []
              }
              renderInput={(params) => <TextField {...params} />}
            />
          </div>

          <div className="customInputWrpr mt-3">
            <p className="mb-1">Created By</p>
            <Autocomplete
              name="filters.created_by.value"
              multiple
              id="filters.created_by.value"
              options={EmployeeListPageResponse?.data || []}
              className="w-100"
              getOptionLabel={(option) => option?.first_name}
              getOptionValue={(option) => option?._id} //
              defaultValue={[]}
              filterSelectedOptions
              size="small"
              limitTags={2}
              onChange={(event, newValue) => {
                searchFormik.setFieldValue(
                  "filters.created_by.value",
                  newValue
                );
              }}
              onBlur={searchFormik.handleBlur}
              value={searchFormik.values?.filters?.created_by?.value || []}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>

          <div className="d-flex gap-3 justify-content-sb">
            <CustomButton type="submit" label="Filter" />
            <CustomButton
              btnType="secondary"
              label="Reset"
              onClick={() => {
                handleFilterClose();
                handleFilter();
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default VisitorLogsdFilter;
